import React, {useEffect, useState} from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import LeadSuccess from '../leadSuccess';
import {connect} from 'react-redux';
import Config from '../../../../Config';

const IvrForm = (props) => {
  const env_num = props.headerData?.tabIndex;
  const [envType, setEnvType] = useState('init');

  useEffect(() => {
    if (env_num == 0) setEnvType('private');
    if (env_num == 1) setEnvType('buisness');
  }, [env_num]);

  function handlePhoneChange(e) {
    props.onPhoneChange({
      name: e.target.getAttribute('name'),
      value: e.target.value,
    });
  }

  function handleSubmit(e) {
    e.preventDefault();
    props.onSubmit();
  }

  return (
    <>
      {props.showSuccess ? (
        <LeadSuccess title={props.successTitle} subtitle={props.successSubTitle} lead_type={envType} form_list={''} />
      ) : (
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <h1>{props.title}</h1>
            </div>
          </div>
          <div className='row'>
            <div className='col-12'>
              <h2>{props.subtitle}</h2>
            </div>
          </div>
          <div className='row'>
            <div className='col-12'>
              <form onSubmit={handleSubmit}>
                <div className='form-inputs-container'>
                  <span className='required-fields-text'>שדות עם כוכבית הם חובה</span>
                  <TextInput
                    error={props.errors.phone}
                    onChange={handlePhoneChange}
                    value={props.phone}
                    type='tel'
                    placeholder='מספר טלפון'
                    id='ivrFormPhone'
                    name='phone'
                    maxLength='10'
                    autoComplete='off'
                    required='required'
                  />
                </div>
                {props.showError && <div className='pt-2' dangerouslySetInnerHTML={{__html: props.failureText}}></div>}
                <div className='pt-4 pb-4'>
                  <p>
                      {
                        Config.loginPageLegalText &&
                        <span dangerouslySetInnerHTML={{ __html: Config.loginPageLegalText }}></span>
                      }  
                  </p>
                </div>
                <div className='pt-4'>
                  <BtnSubmit onclick={handleSubmit} text='שלח' formid='leadForm' />
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    headerData: state.Header,
  };
};

export default connect(mapStateToProps)(IvrForm);
